import {HttpRequest} from '../Data/HttpRequest'
import {server} from '../Data/BuildEnvironment'

export function list(): HttpRequest {
    return {
        verb: 'GET',
        url: `${server}/parcel-dispatchers`,
        headers: {
            Accept: 'application/json'
        },
    }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/Request/ParcelDispatcherResource.ts